import { combineReducers } from 'redux'

import deleteNode from './items/delete'
import get from './items/get'
import post from './items/post'
import put from './items/put'

export default combineReducers({
  delete: deleteNode,
  get,
  post,
  put
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/items.js